import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, onUnmounted, onDeactivated, onActivated } from 'vue';
import { GlobalHelperFunctions } from '@/common/GlobalHelperFunctions';
// eslint-disable-next-line import/no-cycle
import router from '@/router/router';
import { useToolbarStore } from '@/store/toolbarStore';
import { useApplicationStore } from '@/store/applicationStore';
import QuaySelect from '@/app-components/QuaySelect.vue';
import GatVesselSelect from '@/app-components/GatVesselSelect.vue';
import { useHelperStore } from '@/store/helperStore';
import GatClientSelect from '@/app-components/GatClientSelect.vue';
import numeral from 'numeral';
import type { ProformaLine, ProformaWindow } from '@/types/ProformaTypes';
import { GatResponseResultCategory } from '@/types/GatResponseResult';
import ProformaLinesEdit from './ProformaLinesEdit.vue';
import {
  getTotalVatInLocalCurrency,
  getTotalRebateInLocalCurrency,
  getSubtotalInLocalCurrency,
  getProformaTotalAmountInLocalCurrency,
  recalculateProforma,
} from '../utils/proforma-utils';
import ProformaExchangeRateGrid from './ProformaExchangeRateGrid.vue';
import { useProformaStore } from '../stores/proformaStore';

interface ProformaProps {
  callId: string;
  proformaId: number | string;
  location: 'portcall' | 'proforma';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Proforma',
  props: {
    callId: null,
    proformaId: null,
    location: null
  },
  setup(__props: any) {

const props = __props as {
  callId: string;
  proformaId: number | string;
  location: 'portcall' | 'proforma';
};


const toolbarStore = useToolbarStore();
const applicationStore = useApplicationStore();
const helperStore = useHelperStore();
const isLoading = ref(false);
const saving = ref(false);

const proformaStore = useProformaStore();

function onHarbourChanged(harbourId: number) {
  proformaStore.proformaWindow!.proformaInfo.HARBOUR_ID = harbourId;
}

function onUpdateProformaWindow(newProformaWindow: ProformaWindow) {
  proformaStore.proformaWindow = recalculateProforma(
    newProformaWindow.proformaLines,
    newProformaWindow.currencies,
    newProformaWindow.proformaInfo
  );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function onLineUpdated({ line, field }: { line: ProformaLine; field?: any }) {
  const proformaLines = [...proformaStore.proformaWindow!.proformaLines];
  const idx = proformaLines.findIndex((l) => l.ID === line.ID);
  if (typeof idx !== 'undefined' && idx >= 0) {
    // console.log(line, field);
    proformaLines.splice(idx, 1, line);
  }
  /* proformaWindow.value!.proformaLines = proformaLines; */
  const newProformaWindow = recalculateProforma(
    proformaLines,
    proformaStore.proformaWindow!.currencies,
    proformaStore.proformaWindow!.proformaInfo
  );
  proformaStore.proformaWindow = newProformaWindow;
}

async function onSaveClicked() {
  // Send the proforma to the backend
  try {
    const response = await proformaStore.updateProformaWindow(props.proformaId.toString(), {
      Value: proformaStore.proformaWindow!,
      OrgValue: proformaStore.orgProformaWindow!,
    });
    if (response.resultCategory === GatResponseResultCategory.Success) {
      router.back();
    }
  } finally {
    saving.value = false;
  }
}

const userCanEdit = computed(() => applicationStore.userRight('PR.EDIT'));

const userCanEditProformaCalculationCriterias = computed(
  () =>
    false /* This feature is not supported in the web module yet. When it is supported, you can remove this boolean and user userCanEdit instead. */
);

function globalFormatDateTime(date: any, format: any) {
  return GlobalHelperFunctions.globalFormatDateTime(date, format);
}

async function getProforma(proformaId: string) {
  isLoading.value = true;

  try {
    await proformaStore.fetchProformaWindow(proformaId);
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
}

function setBackNavigation() {
  const result = [];
  if (props.location === 'portcall' && props.callId) {
    result.push({ text: 'port call', href: `/call/${props.callId}` });
    result.push({ text: 'proforma list', href: `/call/${props.callId}/proforma` });
  }
  if (props.location === 'proforma' && props.proformaId) {
    result.push({ text: 'proforma', href: `/proforma/${props.proformaId}` });
    result.push({ text: 'proforma list', href: `/proforma` });
  }
  toolbarStore.setBackNavigation(result);
}

watch(
  () => props.proformaId,
  (newValue) => {
    if (newValue) {
      getProforma(newValue.toString());
    }
  },
  { immediate: true }
);

onMounted(() => {
  setBackNavigation();
});

onActivated(() => {
  setBackNavigation();
});

onUnmounted(() => {
  toolbarStore.setBackNavigation(undefined);
});

onDeactivated(() => {
  toolbarStore.setBackNavigation(undefined);
});

return { __sfc: true,props, toolbarStore, applicationStore, helperStore, isLoading, saving, proformaStore, onHarbourChanged, onUpdateProformaWindow, onLineUpdated, onSaveClicked, userCanEdit, userCanEditProformaCalculationCriterias, globalFormatDateTime, getProforma, setBackNavigation, QuaySelect, GatVesselSelect, GatClientSelect, numeral, ProformaLinesEdit, getTotalVatInLocalCurrency, getTotalRebateInLocalCurrency, getSubtotalInLocalCurrency, getProformaTotalAmountInLocalCurrency, ProformaExchangeRateGrid }
}

})